import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbMission } from '@/models/alodb/AloDbMission'
import { ApiResultCode } from '@/models/response/AlrBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { AloDbRoleMapping } from '@/models/alodb/AloDbRoleMapping'



export default {  
  getAdminMissions(): AxiosPromise<AlrContainer<AloBaseArray<AloDbMission>>> {
    
    return apiHelpers.apiCall({ 
      url: 'api/admin/mission', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbMission>>(JSON.parse(data),AloDbMission.createAloDbMissionArray)
      }]
    })
  },
  getAdminMission(id:number):AxiosPromise<AlrContainer<AloDbMission>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/mission/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbMission>(JSON.parse(data),AloDbMission.createAloDbMissionWithDetail)
      }]
    })
  },
  saveAdminMission(adminMission:AloDbMission):AxiosPromise<AlrContainer<AloDbMission>> {
    if(adminMission.MIS_ID && adminMission.MIS_ID > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/mission/${adminMission.MIS_ID}`, 
        method: 'PUT',
        data: adminMission,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbMission>(JSON.parse(data),AloDbMission.createAloDbMissionWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/mission`, 
        method: 'POST',
        data: adminMission,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbMission>(JSON.parse(data),AloDbMission.createAloDbMissionWithDetail)
        }]
      })    
    }    
  },
  deleteAdminMission(id:number):AxiosPromise<AlrContainer<AloDbMission>> {    
    return  apiHelpers.apiCall({ 
      url: `api/admin/mission/${id}`, 
      method: 'DELETE',      
      transformResponse: [function (data:string) {          
        return new AlrContainer<any>(JSON.parse(data),i => i)
      }]
    })       
  },
  getAdminMissionRoleMap(id:number, explicit:boolean):AxiosPromise<AlrContainer<AloBaseArray<AloDbRoleMapping>>>{
    return apiHelpers.apiCall({ 
      //url: `api/admin/user/${id}/rolemap/`, 
      url: `api/admin/rolemap/?mapid=${id}&obj=mission&explicit=${explicit?1:0}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbRoleMapping>>(JSON.parse(data),AloDbRoleMapping.createAloDbRoleMappingArray)
      }]
    })
  },
  //api/admin/mission/107/met-update
  updateMeasureType(id:number):AxiosPromise<AlrContainer<any>> {    
    return  apiHelpers.apiCall({ 
      url: `api/admin/mission/${id}/met-update`, 
      method: 'GET'/*,      
      transformResponse: [function (data:string) {          
        return new AlrContainer<any>(JSON.parse(data),i => i)
      }]*/
    })       
  },
  /*,
  getMissionPlanConfig(misId:number): AxiosPromise<AlrContainer<IrisrawModExpectedNMEA>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/expectednmea/${gliId}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModExpectedNMEA>(JSON.parse(data),IrisrawModExpectedNMEA.createIrisrawModExpectedNMEA)
      }]
    })
  },
  saveMissionPlanConfig(gliId:number, expectedNMEAConfig:IrisConfigContainer<IExpectedNMEAConfig>): AxiosPromise<AlrContainer<IrisrawModExpectedNMEA>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/expectednmea/${gliId}/`, 
      method: 'PUT',
      data:expectedNMEAConfig,
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModExpectedNMEA>(JSON.parse(data),IrisrawModExpectedNMEA.createIrisrawModExpectedNMEA)
      }]
    })
  }   */
}